import { ThemeText } from "@/components/Theme/ThemeText";
import { ThemeView } from "@/components/Theme/ThemeView";
import { MarkdownExtended } from "@/utils/Markdown/MarkdownExtended";

export function viewParser(node) {

    const content = String(node.attributes.content ?? "");

    return (
        <ThemeView key={node.key} {...node?.attributes}>
            <ThemeText>
                <MarkdownExtended text={content} />
            </ThemeText>
        </ThemeView>
    )
}